// 构建扩展语法配置
const buildConfig = (tagName, ext = {}) => {
  return {
    label: tagName.substring(1), // 需要提示的关键字
    kind: 18, // 对应monaco.languages.CompletionItemKind.Text
    insertText: `<${tagName}></${tagName}>`, // 确认后输入的内容
    insertTextRules: 4,
    ...ext
  }
}

/**
 * 系统扩展的语法
 * @author Caesar Liu
 * @date 2020-11-20 17:42
 */
module.exports = [
  buildConfig('@fork', {
    documentation: '复用目标模版内容\ne.g: <@fork alias=\'aliasA\'/>',
    insertText: '<@fork alias=\'${1:alias}\'/>'
  }),
  buildConfig('@check', {
    documentation: '验证模版是否可用\ne.g:\n<@check message=\'错误消息\' condition=\'expression\' />\n当expression执行结果返回\'false\'字符串时系统将自动提示错误消息',
    insertText: '<@check message=\'${1:message}\' condition=\'${2:expression}\'/>'
  }),
  buildConfig('@import', {
    documentation: '引入模版对象\ne.g:\n1. <@import alias=\'目标模版别名\' var=\'var1\'/>\n2. 则可得${var1._fileName}为获取目标模版产生的文件名称',
    insertText: '<@import alias=\'${1:alias}\' var=\'${2:variable}\'/>'
  })
]
